<template>
  <div>
    <v-card class="pa-0 pb-10" tile>
      <v-card-title class="d-flex align-center">
        <h4 class="primary--text mb-0">
          {{ $t('spedilink.offers.title') }}
        </h4>
        <v-spacer />
        <v-btn v-if="!isGuest" outlined class="mr-2" @click="companyBlacklistDialog = true">
          {{ $t('spedilink.companyBlacklist.button') }}
        </v-btn>
        <v-btn v-if="!isGuest" outlined @click="blacklistDialog = true">
          {{ $t('spedilink.blacklist.button') }}
        </v-btn>
      </v-card-title>

      <div class="background px-6 my-4">
        <v-tabs
          v-model="activeTab"
          :height="60"
          background-color="background"
          show-arrows
          hide-slider
          center-active
        >
          <v-tab>{{ $t('spedilink.offers.cargo') }}</v-tab>
          <v-tab>{{ $t('spedilink.offers.vehicle') }}</v-tab>
          <v-tab>{{ $t('spedilink.offers.archive') }}</v-tab>
        </v-tabs>
      </div>

      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <v-card class="py-5">
            <SpedilinkOffersTable
              ref="cargoOffersTable"
              :type="1"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="py-5">
            <SpedilinkOffersTable
              ref="vehicleOffersTable"
              :type="2"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <v-card class="py-5">
            <SpedilinkArchiveTable ref="archiveTable" />
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>

    <SpedilinkBlacklistDialog
      v-model="blacklistDialog"
    />

    <SpedilinkCompanyBlacklistDialog
      v-model="companyBlacklistDialog"
    />
  </div>
</template>

<script>
import SpedilinkOffersTable from '@/views/Spedilink/tables/SpedilinkOffersTable'
import SpedilinkArchiveTable from '@/views/Spedilink/tables/SpedilinkArchiveTable'
import SpedilinkBlacklistDialog from '@/views/Spedilink/dialogs/SpedilinkBlacklistDialog'
import SpedilinkCompanyBlacklistDialog from '@/views/Spedilink/dialogs/SpedilinkCompanyBlacklistDialog'

export default {
  name: 'SpedilinkOffers',
  components: {
    SpedilinkOffersTable,
    SpedilinkArchiveTable,
    SpedilinkBlacklistDialog,
    SpedilinkCompanyBlacklistDialog
  },
  data () {
    return {
      activeTab: 0,
      blacklistDialog: false,
      companyBlacklistDialog: false
    }
  },
  computed: {
    isGuest () {
      return this.$store.getters.isGuest
    }
  },
  methods: {
    refreshAllTabs () {
      const cargoTable = this.$refs.cargoOffersTable
      const vehicleTable = this.$refs.vehicleOffersTable
      const archiveTable = this.$refs.archiveTable

      if (cargoTable) {
        cargoTable.loadOffers()
      }
      if (vehicleTable) {
        vehicleTable.loadOffers()
      }
      if (archiveTable) {
        archiveTable.loadArchived()
      }
    },
    refreshActiveTab () {
      if (this.activeTab === 0 && this.$refs.cargoOffersTable) {
        this.$refs.cargoOffersTable.loadOffers()
      } else if (this.activeTab === 1 && this.$refs.vehicleOffersTable) {
        this.$refs.vehicleOffersTable.loadOffers()
      } else if (this.activeTab === 2 && this.$refs.archiveTable) {
        this.$refs.archiveTable.loadArchived()
      }
    }
  },
  watch: {
    blacklistDialog (isOpen, wasOpen) {
      if (wasOpen && !isOpen) {
        this.$nextTick(() => {
          this.refreshAllTabs()
        })
      }
    },
    companyBlacklistDialog (isOpen, wasOpen) {
      if (wasOpen && !isOpen) {
        this.$nextTick(() => {
          this.refreshAllTabs()
        })
      }
    },
    activeTab () {
      this.$nextTick(() => {
        this.refreshActiveTab()
      })
    }
  }
}
</script>

<style scoped>
.v-tab::before {
  display: block;
  content: attr(title);
  font-weight: bold;
  height: 0;
  overflow: hidden;
  visibility: hidden;
}

.v-tab:hover {
  color: var(--v-primary-base) !important;
  text-shadow: 0 0 .7px var(--v-primary-base), 0 0 .7px var(--v-primary-base);
}

.v-tab--active:hover,
.v-tab--active {
  font-weight: bold;
  color: var(--v-primary-base) !important;
  text-shadow: none;
}

.v-tab {
  border-left: solid 1px var(--v-separator-base);
  margin: 10px 0;
}

.v-tab:last-child {
  border-right: solid 1px var(--v-separator-base);
  margin: 10px 0;
}
</style>
